import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=2b2c1bbc"
import script from "./MemberEdit.vue?vue&type=script&lang=js"
export * from "./MemberEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports